enum TimeFetchingType {
  From = 0,
  Latest,
}

export default TimeFetchingType;
